import { AlertTriangle, Check, Clock, FileText, Camera, Upload, Bell, Building2 } from "lucide-react";
import { BrowserFrame, PhoneFrame, Pill, NAVY, MINT } from "./Frames";

const Row = ({ name, sub, tone, label }) => (
  <li className="flex items-center gap-3 py-2">
    <span className="min-w-0 flex-1">
      <span className="block text-[12.5px] font-semibold truncate" style={{ color: NAVY }}>{name}</span>
      {sub && <span className="block text-[11px] text-slate-500 truncate">{sub}</span>}
    </span>
    <Pill tone={tone}>{label}</Pill>
  </li>
);

export function PortalScreen() {
  const docs = [["Cartão de cidadão", "ok", "Recebido"], ["Caderneta predial", "ok", "Recebido"], ["Certidão permanente", "warn", "Falta enviar"]];
  return (
    <PhoneFrame title="portal do cliente" tid="shot-portal">
      <div className="flex items-center gap-2">
        <span className="w-7 h-7 rounded-lg grid place-items-center text-white text-[11px] font-bold" style={{ background: "#1F4E79" }}>CA</span>
        <span className="text-[12px] font-bold" style={{ color: "#1F4E79" }}>Casa Atlântico</span>
      </div>
      <p className="mt-3 text-[15px] font-bold leading-snug" style={{ color: NAVY }}>Olá, Inês. Falta 1 documento para a sua venda.</p>
      <p className="text-[11px] text-slate-500 mt-1">Pedido por Rui Teixeira, o seu consultor.</p>
      <ul className="mt-3 divide-y divide-slate-100">{docs.map(([n, t, l]) => <Row key={n} name={n} tone={t} label={l} />)}</ul>
      <div className="mt-3 grid grid-cols-2 gap-2">
        <span className="rounded-xl py-2.5 text-white text-[12px] font-semibold flex items-center justify-center gap-1.5" style={{ background: "#1F4E79" }}><Camera size={14} /> Fotografar</span>
        <span className="rounded-xl py-2.5 border border-slate-200 text-[12px] font-semibold flex items-center justify-center gap-1.5" style={{ color: NAVY }}><Upload size={14} /> Ficheiro</span>
      </div>
    </PhoneFrame>
  );
}

export function AlertScreen() {
  return (
    <BrowserFrame title="documentos do processo" tid="shot-alert">
      <div className="text-[11px] font-bold tracking-[0.12em] uppercase text-slate-400">CA-0142 · escritura a 28 nov</div>
      <ul className="mt-2 divide-y divide-slate-100">
        <Row name="Caderneta predial" sub="Lida e confirmada" tone="ok" label="Verificado" />
        <li className="py-2.5">
          <div className="flex items-center gap-3">
            <span className="min-w-0 flex-1 text-[12.5px] font-semibold" style={{ color: NAVY }}>Cartão de cidadão · Inês Moura</span>
            <Pill tone="bad"><AlertTriangle size={11} /> Caduca antes da escritura</Pill>
          </div>
          <p className="mt-1.5 text-[11.5px] text-slate-600">Válido até 21 nov. A escritura está marcada para 28 nov. Peça o cartão novo.</p>
        </li>
        <Row name="Certidão permanente" sub="Falta a página 2" tone="warn" label="Incompleto" />
      </ul>
    </BrowserFrame>
  );
}

export function CmiScreen() {
  const f = [["Proprietária", "Inês Moura · NIF 2•• ••• •••"], ["Imóvel", "T3 · Rua das Gaivotas 12, Cascais"], ["Artigo matricial", "4821 · Cascais e Estoril"], ["Preço", "385 000,00 €"], ["Comissão", "5 % + IVA"]];
  return (
    <BrowserFrame title="contrato de mediação" tid="shot-cmi">
      <div className="flex items-center justify-between gap-2">
        <span className="text-[13px] font-bold" style={{ color: NAVY }}>Contrato de mediação imobiliária</span>
        <Pill tone="ok"><Check size={11} /> Preenchido</Pill>
      </div>
      <dl className="mt-3 space-y-1.5">
        {f.map(([k, v]) => (
          <div key={k} className="grid grid-cols-[110px_1fr] gap-2 text-[11.5px]"><dt className="text-slate-500">{k}</dt><dd className="font-medium truncate" style={{ color: NAVY }}>{v}</dd></div>
        ))}
      </dl>
      <div className="mt-4 flex gap-2">
        <span className="rounded-lg text-white text-[12px] font-semibold px-3 py-2" style={{ background: NAVY }}>Rever e enviar</span>
        <span className="rounded-lg border border-slate-200 text-[12px] font-semibold px-3 py-2 flex items-center gap-1.5" style={{ color: NAVY }}><FileText size={13} /> PDF</span>
      </div>
    </BrowserFrame>
  );
}

const Stat = ({ label, value, sub }) => (
  <div className="rounded-xl border border-slate-100 p-3">
    <div className="text-[10.5px] text-slate-500">{label}</div>
    <div className="text-[16px] font-extrabold tracking-tight mt-0.5" style={{ color: NAVY }}>{value}</div>
    {sub && <div className="text-[10.5px] text-slate-500 mt-0.5">{sub}</div>}
  </div>
);

export function OverviewScreen() {
  const lost = [["Proprietário desistiu", 3], ["Crédito recusado", 2], ["Vendeu por outra agência", 1]];
  return (
    <BrowserFrame title="visão da agência" tid="shot-overview">
      <div className="grid grid-cols-3 gap-2">
        <Stat label="Comissão prevista · 60 dias" value="41 200 €" sub="9 escrituras" />
        <Stat label="Escrituras com pendentes" value="3" sub="de 9 marcadas" />
        <Stat label="Negócios perdidos · ano" value="6" />
      </div>
      <div className="mt-3 text-[11px] font-semibold text-slate-500">Perdidos por motivo</div>
      <ul className="mt-1.5 space-y-1.5">
        {lost.map(([m, n]) => (
          <li key={m} className="flex items-center gap-2 text-[11.5px]">
            <span className="w-40 truncate" style={{ color: NAVY }}>{m}</span>
            <span className="h-2 rounded-full" style={{ width: `${n * 22}px`, background: NAVY, opacity: 0.25 + n * 0.2 }} />
            <span className="text-slate-500">{n}</span>
          </li>
        ))}
      </ul>
    </BrowserFrame>
  );
}

export function ConsultorMini() {
  return (
    <PhoneFrame title="o meu dia do consultor" tid="shot-consultor" className="scale-[0.92]">
      <p className="text-[13px] font-bold" style={{ color: NAVY }}>O meu dia · 2 coisas</p>
      <ul className="mt-2 space-y-2">
        <li className="rounded-lg border border-slate-100 p-2 text-[11px]"><span className="font-semibold" style={{ color: NAVY }}>Gerar o CMI da Rua das Gaivotas</span><span className="block text-slate-500">Tem todos os dados</span></li>
        <li className="rounded-lg border border-slate-100 p-2 text-[11px] flex items-center gap-2"><Bell size={13} style={{ color: MINT }} /><span><span className="font-semibold" style={{ color: NAVY }}>Lembrar o Sr. Paulo</span><span className="block text-slate-500">certidão permanente</span></span></li>
      </ul>
      <div className="mt-3 rounded-lg p-2 text-[11px]" style={{ background: "#E9F8F3", color: "#0B7A5E" }}>A receber este mês · 6 450 €</div>
    </PhoneFrame>
  );
}

export function GestaoMini() {
  const cols = [["CPCV", 4], ["Documentos", 6], ["Marcada", 3]];
  return (
    <BrowserFrame title="painel da gestão processual" tid="shot-gestao">
      <div className="grid grid-cols-3 gap-2">
        {cols.map(([c, n]) => (
          <div key={c} className="rounded-lg bg-slate-50 p-2">
            <div className="text-[10.5px] font-semibold text-slate-500">{c} · {n}</div>
            <div className="mt-1.5 space-y-1.5">{[0, 1].map((i) => <div key={i} className="rounded-md bg-white border border-slate-100 p-1.5 text-[10px]" style={{ color: NAVY }}>CA-01{4 + i}{n}<span className="block text-slate-400"><Clock size={9} className="inline mr-0.5" />à espera do cliente</span></div>)}</div>
          </div>
        ))}
      </div>
    </BrowserFrame>
  );
}

export function DirecaoMini() {
  return (
    <BrowserFrame title="equipa" tid="shot-direcao">
      <ul className="divide-y divide-slate-100">
        {[["Rui Teixeira", "7 angariações", "2 escrituras"], ["Sara Lemos", "5 angariações", "3 escrituras"], ["Hugo Prata", "4 angariações", "1 escritura"]].map(([n, a, e]) => (
          <li key={n} className="py-1.5 flex items-center gap-2 text-[11px]">
            <span className="w-6 h-6 rounded-full grid place-items-center text-[9.5px] font-bold text-white" style={{ background: NAVY }}>{n.split(" ").map((x) => x[0]).join("")}</span>
            <span className="flex-1 font-semibold" style={{ color: NAVY }}>{n}</span>
            <span className="text-slate-500">{a} · {e}</span>
          </li>
        ))}
      </ul>
      <div className="mt-2 text-[10.5px] text-slate-500 flex items-center gap-1"><Building2 size={10} /> Os processos ficam na agência quando um consultor sai.</div>
    </BrowserFrame>
  );
}
